import { S, extKm } from '../globals.js';
import { Fonte } from '../components/shared/ArtefatoHelpers.jsx';
/**
 * Portal Manta · Dados
 * Extraído de portal_manta_v28_12.jsx
 * v29 modular · 2026-05-11
 */

export const KPIS_QUALI_SCHEMA = {
  blocoA: {
    titulo: 'A · Identificação',
    icone: '🆔',
    campos: [
      {k:'nome',          label:'Nome do estudo',        tipo:'text',   placeholder:'Ex: Lote 1 PR · Concessão Federal'},
      {k:'codManta',      label:'Código Manta',          tipo:'text',   placeholder:'Ex: MNT-PR-L1-2026'},
      {k:'ufPrincipal',   label:'UF principal',          tipo:'select', opcoes:['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO']},
      {k:'ufsSec',        label:'UFs secundárias',       tipo:'text',   placeholder:'Ex: SP, MS (se rodovia cruza estados)'},
      {k:'cidade',        label:'Município sede',        tipo:'text',   placeholder:'Ex: Curitiba'},
      {k:'tipoObra',      label:'Tipo de obra',          tipo:'select', opcoes:['Concessão Rodoviária Federal','Concessão Rodoviária Estadual','PPP Patrocinada','PPP Administrativa','EPC Privado','EPC Público','Obra Pública DNIT','Obra Pública DER','Metrô','Ferrovia','Aeroporto']},
    ],
  },
  blocoB: {
    titulo: 'B · Stakeholders',
    icone: '🤝',
    campos: [
      {k:'concessionaria', label:'Concessionária / Consórcio', tipo:'text', placeholder:'Ex: Lote 1 Rodovias Paranaenses S.A.'},
      {k:'regulador',      label:'Regulador',                  tipo:'select', opcoes:['ANTT','ARTESP','AGEPAR','AGERGS','ARSESP','AGER-MT','DNIT','DER','Outro']},
      {k:'fiscalSec',      label:'Fiscalização secundária',    tipo:'text', placeholder:'Ex: PRF, BPRv, Polícia Militar'},
      {k:'financiador',    label:'Financiador esperado',       tipo:'select', opcoes:['BNDES','IFC','BID','Banco Mundial','Mercado de capitais','Recursos próprios','Banco do Brasil','Caixa','A definir']},
    ],
  },
  blocoC: {
    titulo: 'C · Contexto geográfico e climático',
    icone: '🌎',
    campos: [
      {k:'ctxRural',       label:'% rural',              tipo:'number', sufixo:'%', min:0, max:100},
      {k:'ctxUrbano',      label:'% urbano',             tipo:'number', sufixo:'%', min:0, max:100},
      {k:'ctxSerra',       label:'% serra',              tipo:'number', sufixo:'%', min:0, max:100},
      {k:'chuvaMM',        label:'Chuva anual',          tipo:'number', sufixo:'mm/ano'},
      {k:'chuvaDias',      label:'Dias de chuva/ano',    tipo:'number', sufixo:'dias'},
      {k:'chuvaRegime',    label:'Regime de chuvas',     tipo:'select', opcoes:['Tropical','Subtropical','Semi-árido','Equatorial','Regular','Sazonal seca','Sazonal úmida']},
      {k:'altitudeMedia',  label:'Altitude média',       tipo:'number', sufixo:'m'},
      {k:'biomaPredominante', label:'Bioma predominante', tipo:'select', opcoes:['Mata Atlântica','Cerrado','Amazônia','Caatinga','Pampa','Pantanal','Misto']},
    ],
  },
  blocoD: {
    titulo: 'D · Contexto contratual',
    icone: '📝',
    campos: [
      {k:'prazoAnos',      label:'Prazo de concessão',         tipo:'number', sufixo:'anos'},
      {k:'dataEstudo',     label:'Data do estudo',             tipo:'date'},
      {k:'nivelDetalhe',   label:'Nível de detalhe',           tipo:'select', opcoes:['Conceitual','EVTEA','Anteprojeto','Projeto Básico','Projeto Executivo','PER + MEF']},
      {k:'fonteOrcamento', label:'Fonte do orçamento',         tipo:'select', opcoes:['SICRO','SINAPI','Composição própria','SBC','SCO','Híbrido']},
      {k:'anoBaseSicro',   label:'Ano-base SICRO/referência',  tipo:'select', opcoes:['2026','2025','2024','2023','2022','2021','2020']},
      {k:'notas',          label:'Observações livres',         tipo:'textarea', placeholder:'Notas técnicas adicionais...'},
    ],
  },
};

export const KPIS_QUANTI_SCHEMA = {
  grupo1: {
    titulo: '1 · Extensão',
    icone: '📏',
    campos: [
      {k:'extKm',           label:'Extensão total',                tipo:'number', sufixo:'km', dec:2},
      {k:'extPistaSimples', label:'Pista simples existente',       tipo:'number', sufixo:'km', dec:2},
      {k:'extPistaDupla',   label:'Pista dupla existente',         tipo:'number', sufixo:'km', dec:2},
      {k:'dupKm',           label:'Duplicação prevista',           tipo:'number', sufixo:'km', dec:2},
      {k:'fxKm',            label:'Faixas adicionais previstas',   tipo:'number', sufixo:'km', dec:2},
      {k:'ciclKm',          label:'Ciclovias',                     tipo:'number', sufixo:'km', dec:2},
    ],
  },
  grupo2: {
    titulo: '2 · OAEs e travessias',
    icone: '🌉',
    campos: [
      {k:'oaeQt',         label:'OAEs total',          tipo:'number', sufixo:'un'},
      {k:'oaeNovasQt',    label:'OAEs novas',          tipo:'number', sufixo:'un'},
      {k:'passQt',        label:'Passarelas',          tipo:'number', sufixo:'un'},
      {k:'areaEscapeQt',  label:'Áreas de escape',     tipo:'number', sufixo:'un'},
    ],
  },
  grupo3: {
    titulo: '3 · Interseções e acessos',
    icone: '🔀',
    campos: [
      {k:'interQt',        label:'Interseções total',       tipo:'number', sufixo:'un'},
      {k:'retornoXQt',     label:'Retornos em X',           tipo:'number', sufixo:'un'},
      {k:'margTrechos',    label:'Vias marginais (trechos)', tipo:'number', sufixo:'trechos'},
      {k:'acessosQt',      label:'Acessos a regularizar',   tipo:'number', sufixo:'un'},
      {k:'travUrbanasQt',  label:'Travessias urbanas',      tipo:'number', sufixo:'un'},
    ],
  },
  grupo4: {
    titulo: '4 · Outros',
    icone: '🛠',
    campos: [
      {k:'correcoesTracadoQt', label:'Correções de traçado',       tipo:'number', sufixo:'un'},
      {k:'ilumCurvasQt',       label:'Iluminação em curvas',       tipo:'number', sufixo:'un'},
      {k:'dispositivosEspQt',  label:'Dispositivos especiais',     tipo:'number', sufixo:'un'},
    ],
  },
};
